var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"components-container",staticStyle:{"margin":"150px"}},[_c('div',[_c('tinymce',{attrs:{"height":300},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_c('el-button',{on:{"click":_vm.save}},[_vm._v("保存")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }